import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';

const HANDOVER_HASH_PATTERN = /^#ht=(.+)$/;

/**
 * Reads a Phoenix UI-switcher fragment token, exchanges it for a session to hydrate AuthService without a login call, and strips the URL fragment to prevent replay on refresh.
 */
@Injectable({ providedIn: 'root' })
export class HandoverGuard {
  constructor(private _auth: AuthService) {}

  async consume(): Promise<void> {
    const match = HANDOVER_HASH_PATTERN.exec(window.location.hash);
    if (!match) {
      return;
    }

    const [, handoverToken] = match;
    window.history.replaceState(
      null,
      '',
      window.location.pathname + window.location.search
    );

    try {
      const { session } = await this._auth
        .exchangeHandoverToken(handoverToken)
        .toPromise();
      await this._auth.hydrateFromHandover(session).toPromise();
    } catch {
      // Expired, replayed, or invalid, fail open to the normal login page.
    }
  }
}

export function handoverInitializerFactory(
  handoverGuard: HandoverGuard
): () => Promise<void> {
  return () => handoverGuard.consume();
}
